<!-- Modal Overlay -->
<div class="modal-overlay" *ngIf="isOpen" [class.closing]="isClosing" (click)="onClose()">
  <div class="modal-container" [class.closing]="isClosing" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Reward Settings</h2>
      <button class="close-button" (click)="onClose()" type="button">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <form [formGroup]="rewardForm" (ngSubmit)="onSave()">
        <!-- Membership Reward Amount -->
        <div class="form-group">
          <div class="form-field">
            <label class="field-label">Membership Reward Amount ($)</label>
            <div class="input-container">
              <input 
                type="number" 
                class="form-input"
                formControlName="membershipRewardAmount"
                placeholder="0.01"
                [min]="membershipRewardMin"
                [max]="membershipRewardMax"
                step="0.1"
                [class.error]="getFieldError('membershipRewardAmount')"
                (keydown)="onNumberKeyDown($event,true)"
                (input)="onNumberInput($event)"
                (paste)="onNumberPaste($event,true)"
                
              >
              <div class="input-controls">
                <button type="button" class="control-button" (click)="incrementValue('membershipRewardAmount')">
                  <img src="/assets/images/rewards/up-arrow.svg" alt="Up" width="12" height="12">
                </button>
                <button type="button" class="control-button" (click)="decrementValue('membershipRewardAmount')">
                  <img src="/assets/images/rewards/down-arrow.svg" alt="Down" width="12" height="12">
                </button>
              </div>
            </div>
            <div class="field-description">Reward earned per membership sold ($0.01 - $20)</div>
            <div class="error-message" *ngIf="getFieldError('membershipRewardAmount')">
              {{ getFieldError('membershipRewardAmount') }}
            </div>
          </div>
        </div>

        <!-- Number of Washes Threshold -->
        <div class="form-group">
          <div class="form-field">
            <label class="field-label">Number of Membership Threshold</label>
            <div class="input-container">
              <input 
                type="number" 
                class="form-input"
                formControlName="numberOfWashesThreshold"
                placeholder="1"
                [min]="numberOfWashesMin"
                [max]="numberOfWashesMax"
                [class.error]="getFieldError('numberOfWashesThreshold')"
                (keydown)="onNumberKeyDown($event,true)"
                (input)="onNumberInput($event)"
                (paste)="onNumberPaste($event,true)"
                
              >
              <div class="input-controls">
                <button type="button" class="control-button" (click)="incrementValue('numberOfWashesThreshold')">
                  <img src="/assets/images/rewards/up-arrow.svg" alt="Up" width="12" height="12">
                </button>
                <button type="button" class="control-button" (click)="decrementValue('numberOfWashesThreshold')">
                  <img src="/assets/images/rewards/down-arrow.svg" alt="Down" width="12" height="12">
                </button>
              </div>
            </div>
            <div class="field-description">Reward for every membership sold</div>
            <div class="error-message" *ngIf="getFieldError('numberOfWashesThreshold')">
              {{ getFieldError('numberOfWashesThreshold') }}
            </div>
          </div>
        </div>

        <!-- Wash Reward Amount -->
        <div class="form-group">
          <div class="form-field">
            <label class="field-label">Membership Threshold Reward Amount ($)</label>
            <div class="input-container">
              <input 
                type="number" 
                class="form-input"
                formControlName="washRewardAmount"
                placeholder="0.01"
                [min]="washRewardMin"
                [max]="washRewardMax"
                step="0.01"
                [class.error]="getFieldError('washRewardAmount')"
                (keydown)="onNumberKeyDown($event, true)"
                (input)="onNumberInput($event)"
                (paste)="onNumberPaste($event, true)"
                
              >
              <div class="input-controls">
                <button type="button" class="control-button" (click)="incrementValue('washRewardAmount')">
                  <img src="/assets/images/rewards/up-arrow.svg" alt="Up" width="12" height="12">
                </button>
                <button type="button" class="control-button" (click)="decrementValue('washRewardAmount')">
                  <img src="/assets/images/rewards/down-arrow.svg" alt="Down" width="12" height="12">
                </button>
              </div>
            </div>
            <div class="field-description">Reward earned for wash threshold ($0.01 - $20)</div>
            <div class="error-message" *ngIf="getFieldError('washRewardAmount')">
              {{ getFieldError('washRewardAmount') }}
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="button-group">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="onCancel()"
          [disabled]="isSubmitting"
        >
          Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-primary" 
          (click)="onSave()"
          [disabled]="isSubmitting || rewardForm.invalid"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
